import { Button, SkeletonButton, Tooltip } from '@dev-spendesk/grapes';
import React from 'react';

import { QuerySuspense } from 'common/components/QuerySuspense';
import { useTranslation } from 'common/hooks/useTranslation';

import { useWalletTransactionForecastOnSelectedTransfersQuery } from '../../../hooks';
import { useCanConfirmInternationalPayments } from '../../../hooks/useCanConfirmInternationalPayments';
import { selectors, useSelectorWithContext } from '../../../redux';

export const ConfirmTransfersButton = ({
  onClick,
}: {
  onClick?: () => void | Promise<void>;
}) => {
  const { t } = useTranslation('global');

  const transfersSelectedCount = useSelectorWithContext(
    selectors.selectTransfersSelectedCount,
  );
  const walletTransactionForecastOnSelectedTransfersQueryState =
    useWalletTransactionForecastOnSelectedTransfersQuery()();

  const {
    canConfirmPayments: canConfirmInternationalPayments,
    reason: internationalPaymentReason,
  } = useCanConfirmInternationalPayments();

  return (
    <QuerySuspense
      queryState={walletTransactionForecastOnSelectedTransfersQueryState}
      loading={<SkeletonButton />}
      fallback={() => (
        <Button
          text={t('invoices.transfer.actions.confirmTransfer', {
            count: transfersSelectedCount,
          })}
          fit="parent"
          variant="primaryBrand"
          onClick={onClick}
        />
      )}
    >
      {({ hasEnoughFunds }) => (
        <Tooltip content={internationalPaymentReason}>
          <Button
            text={t('invoices.transfer.actions.confirmTransfer', {
              count: transfersSelectedCount,
            })}
            fit="parent"
            variant="primaryBrand"
            onClick={onClick}
            isDisabled={
              transfersSelectedCount === 0 ||
              !hasEnoughFunds ||
              !canConfirmInternationalPayments
            }
          />
        </Tooltip>
      )}
    </QuerySuspense>
  );
};
